<template>
  <section class="grey_bg" aria-labelledby="coc-heading">
    <div class="container mt-4">
      <h1 id="coc-heading" class="mt-4 page-title">Code of Conduct</h1>
      <p class="page-subtitle">Securities Dealing Procedures in terms of SEBI (Research Analysts) Regulations, 2014</p>

      <h2 class="mt-4 section-heading">Introduction</h2>
      <p>SEBI has notified the <strong>Securities and Exchange Board of India (Research Analysts) Regulations, 2014</strong>.</p>
      <p>These regulations have been introduced with the objective of fostering transparency in securities research and providing investors with reliable and useful information to make investment decisions.</p>
      <p>These Code of Conduct – Securities Dealing Procedures are being implemented in line with these regulations.</p>

      <h2 class="mt-4 section-heading">Applicability</h2>
      <p>The policy shall be applicable to <strong>Goutam Sharma (Proprietor, Grow With Stocks) (“RA”)</strong>, Research Analyst (SEBI Registration No. <strong>INH000001212</strong>), being the person primarily responsible for the preparation or publication of research reports, providing research reports, making ‘buy, sell/hold’ recommendations, giving price targets or offering an opinion on any security listed or proposed to be listed on a Stock Exchange.</p>

      <h2 class="mt-4 section-heading">1. Code of Conduct for Research Analyst</h2>
      <ul>
        <li><strong>Honesty and Good Faith</strong> – Research Analyst shall act honestly and in good faith.</li>
        <li><strong>Diligence</strong> – Research Analyst shall act with due skill, care and diligence and shall ensure that research reports and stock recommendations are given after thorough analysis.</li>
        <li><strong>Conflict of Interest</strong> – Research Analyst shall effectively address conflicts of interest which may affect the impartiality of its research analysis, research reports or stock recommendations and shall make appropriate disclosures.</li>
        <li><strong>Insider Trading or Front-Running</strong> – Research Analyst shall not engage in insider trading or front-running, including front-running of its own research reports or stock recommendations.</li>
        <li><strong>Confidentiality</strong> – Research Analyst shall maintain confidentiality of research reports and recommendations until the report is made public or recommendations are provided to the respective clients.</li>
        <li><strong>Professional Standard</strong> – Research Analyst shall observe high professional standards while preparing research reports or analysing companies for stock recommendations.</li>
        <li><strong>Compliance</strong> – Research Analyst shall comply with all regulatory requirements applicable to the conduct of its business activities.</li>
      </ul>

      <h2 class="mt-4 section-heading">2. Insider Dealing</h2>
      <p>The Research Analyst shall not trade, make recommendations or publish research with respect to financial instruments while in possession of unpublished price sensitive information.</p>

      <h2 class="mt-4 section-heading">3. No Front-Running</h2>
      <p>Front-running is prohibited. Front-running may arise through:</p>
      <ul>
        <li>Use of client order information, i.e. utilising advance knowledge of pending orders of clients; or</li>
        <li>Information about the timing or contents of research prior to publication to clients.</li>
      </ul>

      <br>
      <p><strong>Name: Goutam Sharma</strong><br>
      Research Analyst<br>
      <strong>Grow With Stocks</strong><br>
      <strong>SEBI Registration No. INH000001212</strong></p>
      <br>
    </div>
  </section>
</template>

<script>
export default {
  name: "CodeOfConduct",
  mounted() {
    document.title = "Code of Conduct | Grow With Stocks";
  }
};
</script>

<style lang="scss" scoped>
.grey_bg {
  min-height: 100vh;
  background: #f7f7f7;
  padding-bottom: 40px;
}
.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 8px;
  word-wrap: break-word;
}
.page-subtitle {
  font-size: 17px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 24px;
}
.section-heading {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin-top: 28px;
  margin-bottom: 12px;
}
p {
  color: #2d2d2d;
  line-height: 1.6;
}
ul {
  margin-bottom: 12px;
}
li {
  margin-bottom: 6px;
  color: #2d2d2d;
  line-height: 1.5;
}
@media only screen and (max-width: 480px) {
  .page-title {
    font-size: 22px;
  }
  .page-subtitle {
    font-size: 15px;
  }
  .section-heading {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CodeOfConduct.vue